module.exports = __webpack_public_path__ + "static/bmw-6ac7143c7db801d2bc7104b03e3373b5.png";